import { render } from "./franka_hand.vue?vue&type=template&id=00b8ced4&scoped=true"
import script from "./franka_hand.vue?vue&type=script&lang=js"
export * from "./franka_hand.vue?vue&type=script&lang=js"

import "./franka_hand.vue?vue&type=style&index=0&id=00b8ced4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b8ced4"]])

export default __exports__